<template>
  <div>
    <b-modal
      no-close-on-backdrop
      v-model="showEditCompanyModal"
      size="xl"
      :title="'Edit '+form.company_name+' Company'"
    >
      <b-tabs v-model="tabIndex" align="center" content-class="mt-3">
        <b-tab title="Details" active style="height:350px; overflow-y:auto;">
          <!-- form start --------------------------- -->
          <b-form v-if="!submiting && !responseSuccess">
            <b-row>
              <b-col cols="6">
                <b-form-group>
                  <label>
                    Company Name:
                    <span class="text-danger">*</span>
                  </label>
                  <b-form-input
                    size="sm"
                    v-model="$v.form.company_name.$model"
                    :state="$v.form.company_name.$dirty ? !$v.form.company_name.$error : null"
                    required
                    placeholder="Enter Company Name"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group>
                  <label>
                    Contact Name:
                    <span class="text-danger">*</span>
                  </label>
                  <b-form-input
                    size="sm"
                    v-model="$v.form.contact_name.$model"
                    :state="$v.form.contact_name.$dirty ? !$v.form.contact_name.$error : null"
                    required
                    placeholder="Enter Contact Name"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="6">
                <b-form-group>
                  <label>
                    Contact Email:
                    <span class="text-danger">*</span>
                  </label>
                  <b-form-input
                    size="sm"
                    v-model="$v.form.contact_email.$model"
                    :state="$v.form.contact_email.$dirty ? !$v.form.contact_email.$error : null"
                    type="email"
                    required
                    placeholder="Enter Contact Email"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group>
                  <label>
                    Corporate Address:
                    <span class="text-danger">*</span>
                  </label>
                  <b-form-input
                    size="sm"
                    v-model="$v.form.corp_address.$model"
                    :state="$v.form.corp_address.$dirty ? !$v.form.corp_address.$error : null"
                    required
                    placeholder="Enter Corporate Address"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="6">
                <b-form-group>
                  <label>PO Number:</label>
                  <b-form-input size="sm" v-model="form.po_number" placeholder="Enter PO Number"></b-form-input>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group>
                  <label>Country:</label>
                  <v-select
                    :class="'form-control-sm'"
                    size="sm"
                    :searchable="true"
                    :clearable="true"
                    label="name"
                    v-model="form.country"
                    placeholder="-- Select Country --"
                    :options="renderCountries"
                  >
                    <template slot="option" slot-scope="option">
                      <country-flag v-if="option.icon" :country="option.icon" size="small" />
                      <span>{{ '&nbsp;'+ option.name }}</span>
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="6">
                <b-form-group>
                  <label>Billing Address:</label>
                  <b-form-input
                    size="sm"
                    v-model="form.billing_add"
                    placeholder="Enter Billing Address"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group>
                  <label>Finance Contact Name:</label>
                  <b-form-input
                    size="sm"
                    v-model="form.bill_name"
                    placeholder="Enter Finance Contact Name"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="6">
                <b-form-group>
                  <label>Finance Contact Email :</label>
                  <b-form-input
                    size="sm"
                    v-model="form.bill_email"
                    type="email"
                    placeholder="Enter Finance Contact Email "
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group>
                  <label>Account Owner:</label>
                  <v-select
                    size="sm"
                    v-model="form.account_user_id_chosen"
                    placeholder="-- Select Account Owner --"
                    :options="renderAccontOwners"
                  ></v-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="6">
                <b-form-group>
                  <label>Parent Company:</label>
                  <v-select
                    size="sm"
                    v-model="form.parent_id_chosen"
                    placeholder="-- Select Parent Company --"
                    :options="renderparentCompanies"
                  ></v-select>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group>
                  <label>Account Status :</label>
                  <b-form-select
                    size="sm"
                    v-model="form.account_type"
                    placeholder="Free"
                    :options="renderAccountStatus"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="6">
                <b-form-group>
                  <label>Billing Model :</label>
                  <b-form-select
                    size="sm"
                    v-model="form.billing_model"
                    placeholder="Free"
                    :options="renderBillingModels"
                  ></b-form-select>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group>
                  <label>Last Renewed Date :</label>
                  <Datepicker
                    size="sm"
                    input-class="custom-date-picker"
                    calendar-class="date-calender"
                    v-model.lazy="form.last_renewed_date"
                    class="form-control"
                  ></Datepicker>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="6">
                <b-form-group>
                  <label>Next Renewal Date :</label>
                  <Datepicker
                    size="sm"
                    input-class="custom-date-picker"
                    calendar-class="date-calender"
                    v-model.lazy="form.next_renewed_date"
                    class="form-control"
                  ></Datepicker>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group>
                  <label>Is Test:</label>
                  <b-form-checkbox v-model="form.is_test" switch>{{form.is_test ? "ON" : "OFF"}}</b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="6">
                <b-form-group>
                  <label>Enable Monitoring :</label>
                  <b-form-checkbox
                    v-model="form.enable_moni_c"
                    switch
                  >{{form.enable_moni_c ? "ON" : "OFF"}}</b-form-checkbox>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group>
                  <label>
                    Minimum FPR Allowed :
                    <span class="text-danger">*</span>
                  </label>
                  <b-form-input
                    size="sm"
                    onkeydown="return event.keyCode !== 69"
                    v-model="$v.form.min_fpr.$model"
                    :state="$v.form.min_fpr.$dirty ? !$v.form.min_fpr.$error : null"
                    type="number"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="6">
                <b-form-group>
                  <label>
                    Maximum Associated Individuals :
                    <span class="text-danger">*</span>
                  </label>
                  <b-form-input
                    size="sm"
                    onkeydown="return event.keyCode !== 69"
                    v-model="$v.form.max_assoc.$model"
                    :state="$v.form.max_assoc.$dirty ? !$v.form.max_assoc.$error : null"
                    type="number"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group>
                  <label>
                    Homepage :
                    <span class="text-danger">*</span>
                  </label>
                  <b-form-select
                    size="sm"
                    v-model="form.homepage"
                    :state="$v.form.homepage.$dirty ? !$v.form.homepage.$error : null"
                    placeholder="due-diligence20"
                    :options="renderHomepages"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="6">
                <b-form-group>
                  <label>
                    Default Landing Page :
                    <span class="text-danger">*</span>
                  </label>
                  <b-form-select
                    size="sm"
                    v-model="$v.form.landing_page.$model"
                    :state="$v.form.landing_page.$dirty ? !$v.form.landing_page.$error : null"
                    placeholder="Please select Landing page"
                    :options="renderLandingPages"
                  ></b-form-select>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group>
                  <label>Development class :</label>
                  <b-form-select
                    size="sm"
                    v-model="form.development_class"
                    placeholder="Please select Development class"
                    :options="renderDevelopmentClasses"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="6">
                <b-form-group>
                  <label>Additional Specific User Emails to send Monitoring :</label>
                  <b-form-input size="sm" type="email" v-model="form.addtl_email"></b-form-input>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group>
                  <label>Select Report Type :</label>
                  <b-form-select
                    size="sm"
                    v-model="form.report_type"
                    placeholder="--Select Report Type--"
                    :options="renderReportTypes"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="6">
                <b-form-group>
                  <label>Search for OpenCorporates :</label>
                  <b-form-checkbox
                    v-model="form.corp_search"
                    switch
                  >{{form.corp_search ? "ON" : "OFF"}}</b-form-checkbox>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group>
                  <label>Allow Upload Remediation Reports :</label>
                  <b-form-checkbox
                    v-model="form.upload_remediation"
                    switch
                  >{{form.upload_remediation ? "ON" : "OFF"}}</b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="6">
                <b-form-group>
                  <label>Support Email :</label>
                  <b-form-input
                    size="sm"
                    v-model="form.support_email"
                    type="email"
                    placeholder="Support Email"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
          <div v-else-if="submiting && !responseSuccess">
            <p>Your Client is being added......</p>
            <b-spinner type="grow" label="Loading..."></b-spinner>
          </div>
          <div v-else>
            <p class="my-2 text-center">
              Your Client has been added successfully.
              <br />
            </p>
          </div>
        </b-tab>
        <b-tab title="Unlock Special Features" style="height:350px; overflow-y:auto;">
          <p>Unlock special features</p>

          <b-form-group label="Enable My Risk Rating on IDD :">
            <b-form-checkbox
              v-model="specialFeaturesForm.riskRating"
              switch
            >{{specialFeaturesForm.riskRating ? "ON" : "OFF"}}</b-form-checkbox>
          </b-form-group>

          <b-row>
            <b-col cols="6" v-for="(specialFeatures,index) in specialFeaturesoptions" :key="index">
              <b-form-group>
                <label>
                  {{specialFeatures.ts_header}}
                  <br />
                  <sub>{{specialFeatures.ts_description}}</sub>
                </label>
                <b-form-checkbox
                  @input="checkBoxValue($event,specialFeatures,index)"
                  :v-model="specialFeatures.ts_index"
                  switch
                >{{specialFeatures.ts_index ? "ON" : "OFF"}}</b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button @click="specialFeaturesFormSubmit">Submit</b-button>
        </b-tab>
      </b-tabs>
      <template v-slot:modal-footer>
        <div class="float-right">
          <b-button
            class="mr-3"
            v-if="!submiting"
            id="close-btn"
            variant="danger"
            @click="resetModal"
          >Close</b-button>
          <b-button
            v-if="!responseSuccess && tabIndex == 0"
            variant="outline-success"
            @click="checkValidation"
          >
            <b-spinner v-if="submiting" type="grow" label="Loading..."></b-spinner>Update
          </b-button>
          <b-button
            v-if="!responseSuccess && tabIndex == 1"
            variant="outline-info"
            @click="editCompany"
          >
            <b-spinner v-if="submiting" type="grow" label="Loading..."></b-spinner>Unlock
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, between, email } from "vuelidate/lib/validators";
import { HTTP } from "../../utils/HTTP";
import { EventBus } from "@/event-bus.js";
import CountryCodes from "../../utils/countryCodes.json";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";

export default {
  name: "EditCompanyForm",
  mixins: [validationMixin],
  components: {
    vSelect,
    Datepicker
  },
  data() {
    return {
      tabIndex: 1,
      specialFeaturesoptions: [],
      specialFeaturesForm: {
        riskRating: false,
        selected: []
      },
      showEditCompanyModal: false,
      renderCountries: CountryCodes.countries,
      renderAccontOwners: [],
      renderparentCompanies: [],
      renderAccountStatus: [
        { value: 0, text: "Free" },
        { value: 1, text: "Paid" },
        { value: 2, text: "Disabled" },
        { value: 3, text: "EA 1000" },
        { value: 4, text: "Internal" },
        { value: 5, text: "Limited" }
      ],
      renderBillingModels: [
        { value: 0, text: "Free" },
        { value: 1, text: "Subscription" },
        { value: 2, text: "PAYG - Monthly billing" }
      ],
      renderHomepages: [
        { value: "due-diligence20", text: "due-diligence20" },
        { value: "due-diligence20-ca", text: "due-diligence20-ca" },
        { value: "due-diligence20-ac", text: "due-diligence20-ac" },
        { value: "due-diligence20-dentsply", text: "due-diligence20-dentsply" },
        { value: "due-diligence20-infraco", text: "due-diligence20-infraco" },
        { value: "due-diligence20-gen", text: "due-diligence20-gen" },
        { value: "due-diligence20-dyson", text: "due-diligence20-dyson" },
        { value: "due-diligence20-meus", text: "due-diligence20-meus" },
        { value: "due-diligence20-sf", text: "due-diligence20-sf" },
        { value: "due-diligence20_b", text: "due-diligence20_b" },
        { value: "due-diligence20-nvs", text: "due-diligence20-nvs" },
        {
          value: "due-diligence20-kongsberg",
          text: "due-diligence20-kongsberg"
        },
        { value: "due-diligence20-alcon", text: "due-diligence20-alcon" },
        { value: "third-parties220", text: "third-parties220" }
      ],
      renderLandingPages: [
        { value: "third-parties220", text: "third-parties220" }
      ],
      renderDevelopmentClasses: [
        { value: "STE", text: "Singapore Technologies Engineering Ltd" },
        { value: "SonovaDistributor", text: "Sonova Distributor" },
        { value: "SonovaSupplier", text: "Sonova Supplier" }
      ],
      renderReportTypes: [
        {
          value: "Sanctions & Enforcements Screening",
          text: "Sanctions & Enforcements Screening"
        },
        { value: "RDC Screening", text: "RDC Screening" },
        { value: "EDD Order", text: "EDD Order" }
      ],
      renderIDDReferences: [],
      renderEntityTypes: [],
      renderFirm: [],
      form: {
        companyId: null,
        company_name: null,
        contact_name: null,
        contact_email: null,
        corp_address: null,
        po_number: null,
        country: null,
        billing_add: null,
        bill_name: null,
        bill_email: null,
        account_user_id_chosen: null,
        parent_id_chosen: null,
        account_type: null,
        billing_model: null,
        last_renewed_date: null,
        next_renewed_date: null,
        is_test: false,
        enable_moni_c: false,
        min_fpr: null,
        max_assoc: null,
        homepage: null,
        landing_page: null,
        development_class: null,
        addtl_email: null,
        report_type: null,
        corp_search: true,
        upload_remediation: false,
        support_email: null
      },
      isLoading: false,
      submiting: false,
      responseSuccess: false
    };
  },
  validations: {
    form: {
      company_name: {
        required
      },
      contact_name: {
        required
      },
      contact_email: {
        required,
        email
      },
      corp_address: {
        required
      },
      min_fpr: {
        required,
        between: between(0, 100)
      },
      max_assoc: {
        required,
        between: between(0, 100)
      },
      homepage: {
        required
      },
      landing_page: {
        required
      }
    }
  },
  created() {
    EventBus.$on("onShowEditModal", value => {
      this.showEditModal(value);
    });
  },
  mounted() {
    this.getAccontOwnersList();
    this.getParentCompanyList();
    this.getSpecialFeature();
  },
  methods: {
    checkBoxValue(event, selectObject, index) {
      // console.log(event);
      // console.log(selectObject);
      // console.log(index);
    },
    specialFeaturesFormSubmit() {},
    async getSpecialFeature() {
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP("post", "v1/getspecialfeature", null, {
          Authorization: token
        });
        this.specialFeaturesoptions = result.data.getspecialfeature;
        // // console.log(this.specialFeaturesoptions);
      } catch (error) {
        return [];
      }
    },
    showEditModal(value) {
      // console.log(value);
      this.showEditCompanyModal = true;
      this.form = value;
      this.form.companyId = value.id;
      this.form.account_user_id_chosen = value.account_user_id;
      this.form.parent_id_chosen = value.parent_id;
      this.form.account_type = value.account_type;
      this.form.billing_model = value.billing_model;
      this.form.is_test = value.is_test == 1 ? true : false;
      this.form.enable_moni_c = value.moni_is_enabled == 1 ? true : false;
      this.form.homepage = null;
      this.form.landing_page = value.landing_page;
      this.form.development_class = value.development_class;
      this.form.corp_search = value.corp_search == 1 ? true : false;
      this.form.upload_remediation =
        value.upload_remediation == 1 ? true : false;
    },
    resetForm() {
      this.form = {
        company_name: null,
        contact_name: null,
        contact_email: null,
        corp_address: null,
        po_number: null,
        country: null,
        billing_add: null,
        bill_name: null,
        bill_email: null,
        account_user_id_chosen: null,
        parent_id_chosen: null,
        account_type: 0,
        billing_model: 0,
        last_renewed_date: null,
        next_renewed_date: null,
        is_test: false,
        enable_moni_c: false,
        min_fpr: null,
        max_assoc: null,
        homepage: null,
        landing_page: null,
        development_class: null,
        addtl_email: null,
        report_type: null,
        corp_search: true,
        upload_remediation: false,
        support_email: null
      };
    },
    resetModal() {
      this.resetForm();
      this.responseSuccess = false;
      this.submiting = false;
      this.isLoading = false;
      this.showEditCompanyModal = false;
    },
    async getAccontOwnersList() {
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP("post", "v1/getaccountownerlist", null, {
          Authorization: token
        });
        this.renderAccontOwners = result.data.accountowner;
      } catch (error) {
        return [];
      }
    },
    async getParentCompanyList() {
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP("post", "v1/getparentcompanylist", null, {
          Authorization: token
        });
        this.renderparentCompanies = result.data.parentcompany;
      } catch (error) {
        return [];
      }
    },
    checkValidation() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      } else {
        this.editCompany();
      }
    },
    async editCompany() {
      let formData = {
        cid: this.form.companyId,
        comp_user: 0,
        company_name: this.form.company_name,
        contact_name: this.form.contact_name,
        contact_email: this.form.contact_email,
        corp_address: this.form.corp_address,
        billing_add: this.form.billing_add ? this.form.billing_add : "",
        po_number: this.form.po_number ? this.form.po_number : "",
        bill_name: this.form.bill_name ? this.form.bill_name : "",
        bill_email: this.form.bill_email ? this.form.bill_email : "",
        country: this.form.country ? this.form.country.name : "",
        account_user_id: this.form.account_user_id_chosen
          ? this.form.account_user_id_chosen.value
          : "",
        parent_id: this.form.parent_id_chosen
          ? this.form.parent_id_chosen.value
          : "",
        account_type: this.form.account_type
          ? this.form.account_type.value
          : "",
        min_fpr: this.form.min_fpr,
        max_assoc: this.form.max_assoc,
        homepage: this.form.homepage.label,
        billing_model: this.form.billing_model
          ? this.form.billing_model.value
          : "",
        development_class: this.form.development_class
          ? this.form.development_class.value
          : "",
        last_renewed_date: this.form.last_renewed_date
          ? this.form.last_renewed_date
          : "",
        next_renewed_date: this.form.next_renewed_date
          ? this.form.next_renewed_date
          : "",
        corp_search: this.form.corp_search ? 1 : 0,
        report_type: this.form.report_type ? this.form.report_type.label : "",
        landing_page: this.form.landing_page.label,
        upload_remediation: this.form.upload_remediation ? 1 : 0,
        support_email: this.form.support_email ? this.form.support_email : "",
        enable_moni: this.form.enable_moni_c ? 1 : 0,
        addtl_email: this.form.addtl_email ? this.form.addtl_email : "",
        company_approver: 0,
        is_test: this.form.is_test ? 1 : 0,
        enable_moni_oval: 0
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP("post", "v1/editcompany", formData, {
          Authorization: token
        });
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch (error) {
        this.isLoading = false;
        this.submiting = false;
      }
    }
  }
};
</script>
<style>
.style-chooser {
  height: calc(1.5em + 0.5rem + 2px);
}
</style>